import { EmbeddedStoreManager } from "../embedded-store-manager/embeddedStoreManager.model";
import { LocationStore } from "../location-store/location-store.model";
import { VisibilityFlag } from "../visibility-flag/visibility-flag.model";


export enum StoreRequestStatus{
    ACTIVE = "ACTIVE", 
    DELETED = "DELETED"
}

export class StoreRequest{
    chainOfStores: string;
    comsy: string;
    dealerCategory: string;
    dealerDescription: string;
    email: string;
    embeddedStoreManager: EmbeddedStoreManager;
    facebookLink: string;
    googlePlace: string;
    googlePlus: string;
    hasEquipmentWithdrawalExcluded: boolean;
    findomesticMonthlyPaymentFw: boolean;
    findomesticStatus: boolean;
    location: LocationStore;
    messengerLink: string;
    posId: string;
    posIdParent: string;
    published?: boolean;
    resellerLink: string;
    reservationLink: string;
    seoDescription: string;
    seoId: string;
    storeDescription: string;
    telephone: string;
    title: string;
    titleSeo: string;
    visibilityFlag: VisibilityFlag;
    whatsapp: string;
    whatsappAddress: string;

    headImageId:number;
    
    documents:number[];
    promotionEvents:number[];
    galleries:number[];
    internalGalleries:number[];
    productServices:number[];
    storeAccesories:number[];


    
}



export class StoreRequestFindAll{
    dimPagina: number;
    numeroPagina: number;
    
}

export class StoreRequestCreate extends StoreRequest{
    constructor(){super();}
}

export class StoreRequestUpdate extends StoreRequest{
    constructor(){super();}
}

export class StoreRequestAccessories{
    accessoryIds: number[];
}

export class StoreRequestDocuments{
    documentIds : number[];
}

export class StoreRequestGalleries{
    galleryIds  : number[];
}

export class StoreRequestHeadImage{
    headImageId   : number;
}

export class StoreRequestInternalGalleries{
    galleryIds  : number[];
}

export class StoreRequestProductServices{
    productServices   : number[];
}

export class StoreRequestPromotionEvent{
    promotionEventsIds : number[];
}

export class StoreRequestPublish{
    published: boolean;
}


export class StoreRequestUpdateMassiveWhatsapp{
    whatsapp: string;
}

export class StoreRequestSearch{
    q: string;
    embeddedManager:string;
    address: string;
    city: string;
    comsy: string;
    dealerCategory: string;
    dealerDescription: string;
    pageNumber: number;
    pageSize: number;
    productServiceIds: number[];
    province: string;
    published: boolean;
    region: string;
    sortBy: string;
    visibilityClickAndCollectSim: boolean;
    visibilityClickAndCollectSmartphone: boolean;
    visibilityManageOpeningClosingTime: boolean;
    visibilityManageOpeningClosingTimeAppointments: boolean;
    visibilityOpeningClosingTime: boolean;
    
}

export class StoreRequestSearchForAppointmentsOpeningClosingHours{
    address: string;
    city: string;
    comsy: string;
    dealerCategory: string;
    dealerDescription: string;
    pageNumber: number;
    pageSize: number;
    productServiceIds: number[];
    province: string;
    published: boolean;
    region: string;
    sortBy: string;
    visibilityClickAndCollectSim: boolean;
    visibilityClickAndCollectSmartphone: boolean;
    visibilityManageOpeningClosingTime: boolean;
    visibilityManageOpeningClosingTimeAppointments: boolean;
    visibilityOpeningClosingTime: boolean;
    q: string;
    
}

export class StoreRequestSearchForOpeningClosingHours{
    address: string;
    city: string;
    comsy: string;
    dealerCategory: string;
    dealerDescription: string;
    pageNumber: number;
    pageSize: number;
    productServiceIds: number[];
    province: string;
    published: boolean;
    region: string;
    sortBy: string;
    visibilityClickAndCollectSim: boolean;
    visibilityClickAndCollectSmartphone: boolean;
    visibilityManageOpeningClosingTime: boolean;
    visibilityManageOpeningClosingTimeAppointments: boolean;
    visibilityOpeningClosingTime: boolean;
    
}


export class StoreRequestUpdateMassiveFlag{
    flags: VisibilityFlag;
    storeIds: number[];
    constructor(){
        this.flags = new VisibilityFlag();
        this.storeIds = [];
    }
}